export const URLS = {
  // system
  VERSION: "/api/version",

  // auth
  USER: "/api/account/user/",
  GROUP: "/api/account/group/",
  MENU: "/api/account/menu/",
  MODULE: "/api/account/module/",
  MODULE_MENU: "/api/account/module_menu/",
  CONTENT_TYPE: "/api/account/content_type/",
  PERMISSION: "/api/account/permission/",
  AUTH: "/api/account/auth/",

  //core
  BOM: "/api/planmat/bom/",
  BOM_COMPONENT: "/api/planmat/bom-component/",
  BOM_FINISHED_GOOD: "/api/planmat/bom/finished-good-list/",
  CUSTOMER: "/api/planmat/customer/",
  PO: "/api/planmat/po/",
  PO_COMPONENT: "/api/planmat/po-components/",
  STOCK: "/api/planmat/stock/",
  COMPONENT: "/api/planmat/component/",
  FORECAST: "/api/planmat/forecast/",
  DOWNLOAD_TEMPLATE: "/api/planmat/download-template/",
  TECHNICAL_DOCUMENTATION: "/api/planmat/technical-documentation/",
  IMPORT_BOM: "/api/planmat/bom/import-bom/",
  IMPORT_STOCK_AND_PO: "/api/planmat/stock/import-stock/",
  IMPORT_STOCK_FROM_SAP: "/api/planmat/stock/import-stock-from-sap/",
  IMPORT_FORECAST: "/api/planmat/forecast/import-forecast/",
  IMPORT_FORECAST_FROM_SAP: "/api/planmat/forecast/import-forecast-from-sap/",
  IMPORT_BOM_FROM_SAP: "/api/planmat/bom/import-bom-from-sap/",
  IMPORT_HISTORY: "/api/planmat/import-history/",
  RFC_EXECUTIONS: "/api/planmat/rfc-executions/",
  ANALYSIS: "/api/planmat/analysis/",
  ANALYSIS_IA: "/api/planmat/analysis-data-ia/",
  ANALYSIS_RESULT: "/api/planmat/analysis-result/",
  ANALYSIS_PRIORITY: "/api/planmat/analysis/boms-by-forecast/",
  ANALYSIS_CREATE: "/api/planmat/analysis/create-analysis/",
  ANALYSIS_REPROCESS: "/api/planmat/analysis/reprocess-analysis/",
  ANALYSIS_EXPORT: "/api/planmat/analysis/export/",
  NOTIFICATION: "/api/planmat/notification/",
  MATERIALS_DEMANDS: "/api/planmat/materials-demands/",
  MATERIAL_STATUS: "/api/planmat/material-status/",
  MATERIAL_STATUS_EXPORTS: "/api/planmat/material-status-exports/",
  STOCK_EXPORT: "/api/planmat/component/export/",
  SETTINGS: "/api/planmat/settings/",
  HUB_STATUS: "/api/planmat/auth/hub_status/",
};
